var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.doctor && _vm.doctor.isCertified && _vm.doctor.onboardingStep >= 5
    ? _c("div", { staticClass: "advertisements-wrapper" }, [
        _vm.advertisements.length
          ? _c("div", { staticClass: "advertisement" }, [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      _vm.advertisements[_vm.currentKey].items[_vm.languageId]
                        .url,
                    target: "_blank"
                  },
                  on: {
                    click: function($event) {
                      return _vm.dispatchAnalyticsEvent("Click")
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "max-width": "100%" },
                    attrs: {
                      src:
                        _vm.advertisements[_vm.currentKey].items[_vm.languageId]
                          .image
                    }
                  })
                ]
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7471c71e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7471c71e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/Advertisements.vue
// module id = 622
// module chunks = 1